import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 15000,
  withCredentials: true,
});

// Auto-redirect to /signin on 401 (only outside auth/billing paths).
// Auto-redirect to /billing on 402 Subscription Required.
let onUnauthorized = null;
let onPaymentRequired = null;
export const setOnUnauthorized = (fn) => { onUnauthorized = fn; };
export const setOnPaymentRequired = (fn) => { onPaymentRequired = fn; };
// Silent session renewal: on a 401, try POST /auth/refresh once (deduped
// across concurrent requests) and replay the original request. Only if the
// refresh itself fails do we treat the user as signed out.
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err?.config || {};
    const url = cfg.url || "";
    const code = err?.response?.status;
    if (code === 401 && !url.includes("/auth/")) {
      if (!cfg._retried) {
        cfg._retried = true;
        try {
          refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
          await refreshing;
          return api(cfg);
        } catch (_) { /* refresh failed — fall through to sign-out */ }
      }
      onUnauthorized?.();
    }
    if (code === 402 && !url.includes("/billing/")) {
      onPaymentRequired?.();
    }
    return Promise.reject(err);
  }
);

export const fmtMoney = (n) =>
  "$" + Math.round(n || 0).toLocaleString("en-US");
export const fmtPct = (n) =>
  `${Math.round((n || 0) * 100)}%`;

export const monthLabel = (ymd) => {
  const [y, m] = ymd.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleString("en-US", {
    month: "long",
    year: "numeric",
  });
};

export const todayIso = () => new Date().toISOString().slice(0, 10);

export const mondayOf = (d = new Date()) => {
  const date = new Date(d);
  const day = (date.getDay() + 6) % 7;
  date.setDate(date.getDate() - day);
  return date.toISOString().slice(0, 10);
};

export const daysInMonth = (month) => {
  const [y, m] = month.split("-").map(Number);
  return new Date(y, m, 0).getDate();
};

export const addDays = (iso, n) => {
  const d = new Date(iso + "T00:00:00");
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
};

export const weekDates = (weekStart) =>
  Array.from({ length: 7 }, (_, i) => addDays(weekStart, i));

export const niceDate = (iso) =>
  new Date(iso + "T00:00:00").toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
  });

export const exportCsv = (filename, rows) => {
  if (!rows || rows.length === 0) return;
  const headers = Object.keys(rows[0]);
  const esc = (v) => {
    if (v == null) return "";
    const s = String(v).replace(/"/g, '""');
    return /[",\n]/.test(s) ? `"${s}"` : s;
  };
  const csv = [
    headers.join(","),
    ...rows.map((r) => headers.map((h) => esc(r[h])).join(",")),
  ].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};
